// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GoPermiumModal_wrapper__dqHdS","modal-header":"GoPermiumModal_modal-header__VCOdi","modal-body":"GoPermiumModal_modal-body__FGBvY"};